import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Award, Tv, MapPin } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
function track(event, extra = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', event, { event_category: 'author_box', ...extra });
    }
  } catch { /* noop */ }
  try {
    fetch(`${API}/api/track/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, source: 'author_box', blog_slug: window.location.pathname.split('/blog/')[1] || null, ...extra }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* noop */ }
}


/**
 * AuthorBox — appears below every blog post.
 * Strengthens E-E-A-T by surfacing author authority on every article page,
 * and provides a strong consultation CTA. Linked to /experts/vivek-virat-mudgal
 * so Google and AI engines can resolve the author entity sitewide.
 */
const AUTHOR_PHOTO = '/media/founder/IMG_9620-removebg-preview.png';

export default function AuthorBox() {
  return (
    <section className="my-10 rounded-3xl bg-gradient-to-br from-bg-card to-bg-secondary border border-gold/30 overflow-hidden" data-testid="blog-author-box" itemScope itemType="https://schema.org/Person">
      <div className="grid sm:grid-cols-[150px_1fr] gap-5 p-6 sm:p-7">
        <div className="flex sm:block items-center justify-center">
          <Link to="/experts/vivek-virat-mudgal" className="block w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-gradient-to-br from-gold/30 via-purple-500/20 to-bg-primary flex items-center justify-center border-2 border-gold/50 overflow-hidden hover:scale-105 transition">
            <img
              src={AUTHOR_PHOTO}
              alt="Vivek Virat Mudgal — Founder of ViratAstro"
              className="w-full h-full object-cover object-top"
              itemProp="image"
            />
          </Link>
        </div>
        <div>
          <div className="flex flex-wrap items-center gap-2 mb-1.5">
            <span className="text-[10px] tracking-[0.25em] uppercase text-gold font-bold">Author</span>
            <span className="text-gold/40">·</span>
            <span className="text-[10px] tracking-[0.25em] uppercase text-purple-300">Founder · ViratAstro</span>
          </div>
          <Link to="/experts/vivek-virat-mudgal" className="hover:text-gold transition">
            <h3 className="text-2xl font-heading font-bold text-text-primary leading-tight" itemProp="name">
              Vivek Virat Mudgal
            </h3>
          </Link>
          <p className="text-xs text-gold/90 font-medium mt-1 mb-3" itemProp="jobTitle">
            Vedic Astrologer · Parashari Jyotish Expert · Vastu Consultant
          </p>
          <p className="text-sm text-text-muted leading-relaxed mb-4" itemProp="description">
            <b className="text-text-primary">33+ years</b> of dedicated practice in Vedic Astrology &amp; Parashari Jyotish. Featured on <b className="text-text-primary">News Nation</b>. Trusted by <b className="text-text-primary">33,000+ clients across 14+ countries</b>. All articles on ViratAstro are written and reviewed by Acharya Vivek जी to ensure shastra-shudh accuracy.
          </p>

          <div className="flex flex-wrap gap-3 text-[11px] text-text-muted mb-4">
            <span className="flex items-center gap-1"><Award className="w-3 h-3 text-gold" /> 33+ years experience</span>
            <span className="flex items-center gap-1"><Tv className="w-3 h-3 text-gold" /> Featured on News Nation</span>
            <span className="flex items-center gap-1"><MapPin className="w-3 h-3 text-gold" /> Faridabad, India</span>
          </div>

          <div className="flex flex-wrap gap-2">
            <Link to="/experts/vivek-virat-mudgal" onClick={() => track('vivek_profile_visit')} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-gold text-bg-primary text-sm font-semibold hover:bg-yellow-400 transition" data-testid="authorbox-profile-link">
              View Full Profile <ArrowRight className="w-3.5 h-3.5" />
            </Link>
            <a
              href="https://wa.me/919311369729?text=Namaste%20Acharya%2C%20I%20would%20like%20to%20book%20a%20consultation."
              target="_blank" rel="noopener noreferrer"
              onClick={() => track('vivek_whatsapp_click')}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-green-600 text-white text-sm font-semibold hover:bg-green-700 transition"
              data-testid="authorbox-whatsapp"
            >
              <Phone className="w-3.5 h-3.5" /> WhatsApp Consultation
            </a>
            <Link to="/poocho-guruji" onClick={() => track('vivek_book_consultation')} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-gold/40 text-gold text-sm font-semibold hover:bg-gold/10 transition" data-testid="authorbox-poocho">
              Pucho Guruji AI
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
